import { apiFetch } from "./checkBundleVersion.js";
import { getToken, clearToken } from "./session.js";
export { getToken, setToken, clearToken, isTokenExpired } from "./session.js";

export function useAuthFetch(options = {}) {
    const { onUnauthorized } = options;

    return async (url, fetchOptions = {}) => {
        const fullUrl = url.startsWith("http") ? url : url;
        const token = getToken();

        const headers = fetchOptions.body instanceof FormData
            ? { ...fetchOptions.headers }
            : { "Content-Type": "application/json", ...fetchOptions.headers };

        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }

        const response = await apiFetch(fullUrl, {
            ...fetchOptions,
            headers,
        });

        if (response.status === 401) {
            clearToken();
            if (onUnauthorized) {
                onUnauthorized();
            } else {
                const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
                window.location.href = `/login?redirect=${returnUrl}`;
            }
            throw new AuthError("Unauthorized", 401);
        }

        if (response.status === 403) {
            throw new AuthError("Forbidden: insufficient permissions", 403);
        }

        return response;
    };
}

export async function authFetch(url, options = {}) {
    const fullUrl = url.startsWith("http") ? url : url;
    const token = getToken();

    const headers = options.body instanceof FormData
        ? { ...options.headers }
        : { "Content-Type": "application/json", ...options.headers };

    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await apiFetch(fullUrl, {
        ...options,
        headers,
    });

    if (response.status === 401) {
        clearToken();
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.href = `/login?redirect=${returnUrl}`;
        throw new AuthError("Unauthorized", 401);
    }

    if (response.status === 403) {
        throw new AuthError("Forbidden: insufficient permissions", 403);
    }

    return response;
}

export class AuthError extends Error {
    constructor(message, status) {
        super(message);
        this.name = "AuthError";
        this.status = status;
    }
}

export { useAuthFetch as default };
